<template>
  <div class="p-4">
    <vs-card class="px-4">
      <div slot="header">
        <span>Selecione a Apólice</span>
      </div>

      <div class="card-section-content">
        <vs-tooltip
          text="Apólices com pontos: insira os 6 últimos números. Apólices sem pontos: insira o número completo."
        >
          <span>
            Nº da Apólice
            <vs-icon
              class="icon-spacing"
              color="primary"
              icon-pack="feather"
              icon="icon-help-circle"
            ></vs-icon>
          </span>
          <the-mask
            class="vs-inputx vs-input--input normal w-full"
            masked
            mask="#############"
            name="codigo"
            id="codigo"
            v-model="policyNumber"
            val-icon-danger="clear"
            data-testId="policy-number-input"
          />
        </vs-tooltip>
        <vs-button
          color="success"
          type="filled"
          icon="search"
          radius
          @click="handlePolicySearch"
          :disabled="!policyNumber"
        />
      </div>

      <div
        class="policy-info"
        v-if="
          activatedPolicy &&
          activatedPolicy.vehicle &&
          activatedPolicy.driver &&
          activatedPolicy.prospect
        "
      >
        <div class="policy-header">
          <h3>
            Apólice Encontrada:
            {{
              formatEmitterNumber(
                activatedPolicy.policyNumber,
                POLICY_TYPES.AUTO,
                'POLICY',
              )
            }}
          </h3>
        </div>

        <div class="section">
          <div class="policy-grid">
            <div class="info-block">
              <strong>Tipo apólice:</strong> Auto anual
            </div>
            <div class="info-block">
              <strong>Data da Apólice:</strong>
              {{ formatDateBr(activatedPolicy.subscription_date) }}
            </div>
          </div>
        </div>

        <div class="section">
          <div class="policy-grid">
            <div class="info-block">
              <strong>Segurado:</strong> {{ activatedPolicy.prospect.name }}
            </div>
            <div class="info-block">
              <strong>Corretora:</strong> {{ activatedPolicy.broker.name }}
            </div>
          </div>
        </div>

        <div class="section">
          <div class="policy-grid">
            <div class="info-block">
              <strong>Início da Vigência:</strong>
              {{ formatDateBr(activatedPolicy.start_of_validity) }}
            </div>
            <div class="info-block">
              <strong>Fim da Vigência:</strong>
              {{ formatDateBr(activatedPolicy.end_of_validity) }}
            </div>
          </div>
        </div>

        <div class="section">
          <div class="policy-grid">
            <div class="info-block">
              <strong>Veículo Zero:</strong>
              {{ activatedPolicy.vehicle.is_brand_new ? 'Sim' : 'Não' }}
            </div>
            <div class="info-block">
              <strong>Placa:</strong> {{ activatedPolicy.vehicle.plate || '' }}
            </div>
            <div class="info-block">
              <strong>Chassi:</strong>
              {{ activatedPolicy.vehicle.chassis || '' }}
            </div>
          </div>
        </div>

        <div class="section">
          <div class="policy-grid">
            <div class="info-block">
              <strong>Marca:</strong>
              {{ activatedPolicy.vehicle.brand }}
            </div>
            <div class="info-block">
              <strong>Modelo/Ano:</strong>
              {{ activatedPolicy.vehicle.model }} /
              {{ activatedPolicy.vehicle.year_model }}
            </div>
          </div>
        </div>

        <div class="button-container">
          <vs-button type="filled" color="primary" @click="createEndorsement">
            Criar Endosso
          </vs-button>
        </div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import policyApi from '../../../services/policy.api';
import dateConversion from '../../../utils/dateConversion';
import functions from '../../../utils/functions';
import { TIPOS_APOLICES } from '../../../utils/constants';
import notify from '../../../utils/notify';
import { POLICY_STATUSES } from '../../../utils/constants';

export default {
  data() {
    return {
      policyNumber: null,
      activatedPolicy: null,
      formatDateBr: dateConversion.convertISOToDate,
      formatEmitterNumber: functions.formatEmitterNumber,
      POLICY_TYPES: TIPOS_APOLICES,
    };
  },
  methods: {
    async handlePolicySearch() {
      if (!this.policyNumber) {
        notify.notifyFail(this.$vs, 'Informe os 6 últimos números da apólice');
        return;
      }

      this.$vs.loading();
      try {
        const isValidPolicyStatus = await this.isValidPolicyStatus();
        if (!isValidPolicyStatus) return;
        this.activatedPolicy = await policyApi.getPolicyByNumber(
          this.policyNumber,
          true,
          true,
          true,
        );
      } catch (error) {
        console.error('Erro ao buscar apólice:', error);
        notify.notifyFail(this.$vs, error.response.data.message);
      } finally {
        this.$vs.loading.close();
      }
    },
    async isValidPolicyStatus() {
      this.policyStatus = await policyApi.getPolicyStatusByNumber(
        this.policyNumber,
      );
      if (this.policyStatus !== POLICY_STATUSES.ACTIVE.id) {
        notify.notifyFail(this.$vs, 'Apólice não está disponível para endosso');
        this.activatedPolicy = null;
        return false;
      }
      return true;
    },
    createEndorsement() {
      const policyNumber = this.activatedPolicy.policyNumber;
      this.$router.push({
        name: 'endosso',
        params: { id: policyNumber },
        query: { identifierType: 'policy' },
      });
    },
  },
};
</script>

<style scoped>
.title {
  text-align: left;
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 16px;
  padding: 8px;
}

.card-section-title {
  padding: 1em;
  background: #d8e2ff;
}

.card-section-title span {
  color: #2b50bb;
  font-weight: 600;
}

.card-section-content {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 1em;
  align-items: flex-end;
  gap: 16px;
}

.custom-select {
  margin-top: 2px;
}

.button-group {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin: 24px 0;
}

.info-field {
  margin: 8px 0;
  font-size: 0.95rem;
}

.policy-info {
  margin-top: 24px;
  padding: 16px;
  background: #f9fafb;
  border-radius: 8px;
}

.policy-header h3 {
  font-size: 1.3rem;
  color: #2b50bb;
  margin-bottom: 16px;
}

.button-container {
  margin-top: 24px;
  text-align: right;
}

.section {
  margin-bottom: 24px;
}

.section h4 {
  font-size: 1.1rem;
  color: #2b50bb;
  margin-bottom: 12px;
}

.policy-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
}

.info-block {
  font-size: 0.95rem;
  background: #ffffff;
  padding: 12px;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
</style>
